import { createFileRoute } from "@tanstack/react-router";
import { MyListPage } from "@/features/mylists/MyListPage";

export const Route = createFileRoute("/_app/my-work/lists/$list")({ component: Page });

function Page() {
  const { list } = Route.useParams();
  return <MyListPage listId={list} />;
}
